import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"

const propertyRootPath = RoutePath.create(
    `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId`
)

export const propertyRoutesPaths = {
    property: propertyRootPath,
    propertyNewContract: propertyRootPath.create("/nouveau-contrat"),
    propertyEnergyLandscape: propertyRootPath.create("/paysage-energetique"),
    propertyMoveOut: propertyRootPath.create("/je-demenage"),
    proofOfAddress: propertyRootPath.create("/justificatif-de-domicile"),
    readingsHistory: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/historique-des-releves?pceRef=:pceRef&prmId=:prmId`
    ),
} as const satisfies RoutePaths
